module.exports = __webpack_public_path__ + "img/galapagosislands.8bdc7095.svg";